module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-51.3f61bd79.svg";